// 首页-产品
<template>
  <div class="home-product">
    <img
      :src="item.icon"
      :alt="item.title"
      class="icon"
      v-for="(item, index) in data"
      :key="`product-item${index + 1}`"
      v-if="index === checkItem"
    />
    <div class="home-product-case">
      <div class="arrow">
        <div
          class="swiper-button-prev"
          :style="{
            color: checkItem == 0 ? 'rgba(255, 255, 255, 0.4)' : '#ffffff'
          }"
        />
      </div>
      <swiper
        ref="swiper"
        :options="options"
        @slide-change-transition-end="handleSlideChangeEnd"
        class="home-product-case-swiper"
      >
        <swiper-slide
          class="home-product-case-items"
          v-for="(item, index) in data"
          :key="`product-item${index + 1}`"
        >
          <div class="home-product-case-items-info">
            <div class="title">{{ item.title }}</div>
            <div class="content">{{ item.content }}</div>
            <div class="more" @click="goPath(item.router)">了解更多></div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="arrow">
        <div
          class="swiper-button-next"
          :style="{
            color:
              checkItem == data.length - 1
                ? 'rgba(255, 255, 255, 0.4)'
                : '#ffffff'
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import iconSociety from "@/../static/img/home/product_society.png";
import iconMake from "@/../static/img/home/product_make.png";
import iconFinancial from "@/../static/img/home/product_financial.png";
import iconDigitization from "@/../static/img/home/product_digitization.png";
import left from "@/../static/img/home/left.png";
import left_tr from "@/../static/img/home/left_tr.png";
import right from "@/../static/img/home/right.png";
import right_tr from "@/../static/img/home/right_tr.png";
export default {
  name: "home-product",
  data() {
    return {
      left,
      left_tr,
      right,
      right_tr,
      data: [
        {
          title: "工业级智能体",
          icon: iconMake,
          content:
            "基于认知智能算法平台，嵌入特定行业的营运知识，专为复杂的工业环境及长流程制造场景而设计。其支持制造工作流程多个阶段的智能流程控制、质量预测、营运监控及生产优化。透过该等产品，企业能够提升营运效率，提高产品质量，减少对经验驱动决策的依赖。",
          router: "/productManufacture"
        },
        // {
        //   title: "AI4Science",
        //   icon: iconDigitization,
        //   content:
        //     "华院计算依托认工业级智能体，在AI4Science 特别是在AI+新药研发、Al+合成生物、Al+医疗器械、Al+再生医学辅助、Al+大健康等5个领域进行创新发展，并取得了显著成绩。",
        //   router: "/productDigitization"
        // },
        // {
        //   title: "社会治理",
        //   icon: iconSociety,
        //   content:
        //     "以“人文精神”和“法治精神”为本，全面赋能数字基层、平安法治、产业发展、乡村振兴，全力推动社会治理实现社会化、法治化、智能化、专业化。",
        //   router: "/productSociety"
        // },
        {
          title: "运营决策智能体",
          icon: iconFinancial,
          content:
            "基于我们的认知智能算法平台，嵌入整个企业营运中，以支持业务流程及通用任务执行。透过整合企业数据、业务规则、领域知识及营运工作流程，该等智能体协助企业进行知识管理、数据分析、任务执行及营运决策。",
          router: "/operationDecision"
        }
      ],
      checkItem: 0,
      options: {
        observer: true,
        speed: 700,
        loop: false,
        slidesPerView: 1,
        observeParents: true,
        observeSlideChildren: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  methods: {
    goPath(path) {
      this.$router.push(path);
    },
    handleSlideChangeEnd() {
      this.checkItem = this.$refs.swiper.swiperInstance.realIndex;
    }
  }
};
</script>
<style lang="less" scoped>
.home-product {
  width: calc(100% - 40px);
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: transparent;
  padding: 0 20px 0px;
  .icon {
    width: 712px;
    height: 390px;
    margin-top: 10%;
    animation: bounce-down 4s linear infinite;
  }
  @keyframes bounce-down {
    0%,
    100% {
      transform: translateY(0);
    }
    25% {
      transform: translateY(15px);
    }
    50% {
      transform: translateY(0);
    }
    75% {
      transform: translateY(-15px);
    }
  }
  .home-product-case {
    width: 100%;
    margin-top: 48px;
    display: flex;
    align-items: center;
    .arrow {
      position: relative;
      width: 10%;
      height: 100%;
      text-align: center;
      z-index: 10;
    }
    .home-product-case-swiper {
      width: 80%;
      display: flex;
      justify-content: space-between;
      --swiper-navigation-color: "#ffffff";
      .home-product-case-items {
        width: 100% !important;
        color: #ffffff;
        text-align: center;
        .home-product-case-items-info {
          padding: 0 15px;
        }
        .title {
          width: 100%;
          font-size: 44px;
          font-weight: 600;
        }
        .content {
          width: 100%;
          font-size: 24px;
          line-height: 44px;
          margin-top: 10px;
          text-align: left;
        }
        .more {
          width: 100%;
          font-size: 30px;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/home_product.vue